import React, { useMemo } from 'react'
import { defaultStyles, DefaultExtensionType } from 'react-file-icon'
import CustomFileIcon from '../custom-file-icon'

export function FileItem({ file }: { file: File | string }): JSX.Element {
  const [name, formattedName] = useMemo(() => getFileName(file), [file])
  const [extension, childProps] = useMemo(() => {
    const idx = name.lastIndexOf('.')
    const ext = idx >= 0 ? name.slice(idx + 1).toLowerCase() : ''

    let type = defaultStyles[ext as DefaultExtensionType]
    if (!type) {
      type = { type: 'document' }
    }

    return [ext, type]
  }, [name])

  return (
    <div className="ellipsis">
      <span className="file-icon me-2 d-inline-block">
        <CustomFileIcon extension={extension} color="#b6e5ff" {...childProps} />
      </span>
      {formattedName}
    </div>
  )
}

function getFileName(file: File | string) {
  let name = typeof file === 'string' ? file : file.name
  name = name.trim()
  let formatted = name

  // Display only a few of last url pathname parts, it url is too long
  const maxLimit = 40
  const minLimit = 2 // prevents the name to be just '/'
  const match = name.match(/^https?:\/\/[^/]+\/[^/]+/)

  if (name.length <= maxLimit || !match) {
    return [name, formatted]
  }

  const pathSegments = extractPathSegments(name)
  const selectedSegments = selectLastSegmentsWithinLimit(pathSegments, maxLimit, minLimit)

  formatted = '.../' + selectedSegments.join('/')

  return [name, formatted]
}

function extractPathSegments(url: string) {
  return url
    .replace(/^https?:\/\//, '')
    .split('/')
    .slice(1)
    .reverse()
}

function selectLastSegmentsWithinLimit(pathSegments: string[], limit: number, minLimit: number) {
  const selected: string[] = []
  let totalLength = 0

  for (const segment of pathSegments) {
    const segmentLength = segment.length + 1 // Adding +1 because of '/'
    const newTotal = totalLength + segmentLength

    if (newTotal <= limit) {
      selected.unshift(segment)
      totalLength = newTotal
    } else {
      if (totalLength < minLimit) {
        selected.unshift(segment)
      }
      break
    }
  }

  return selected
}
